import Flex from '@vromo/ui/components/Flex';
import React, { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { AcceptedFleetOptions } from '../../interfaces';
import styles, { CheckIcon } from './completePage.style';

interface Props {
    acceptedFleetOptions: AcceptedFleetOptions[];
}

const CompletePage = ({ acceptedFleetOptions }: Props) => {
    const { t } = useTranslation();

    const fleetNames: string[] = [];
    acceptedFleetOptions?.forEach((acceptedFleetOption) =>
        acceptedFleetOption?.acceptedFleetNames?.forEach(
            (acceptedFleetName) =>
                !fleetNames.includes(acceptedFleetName) && fleetNames.push(acceptedFleetName)
        )
    );

    return (
        <Flex style={styles.container} direction="column" horizontal="center">
            <Flex style={styles.contentContainer} direction="column" horizontal="center">
                <span style={styles.overlayTitle as CSSProperties}>{t('findFleets.thankYou')}</span>
                <div style={styles.iconContainer}>
                    <CheckIcon viewBox="0 0 24 24">
                        <polyline points="20 6 9 17 4 12" />
                    </CheckIcon>
                </div>
                <Flex style={styles.descriptionContainer} direction="column">
                    <span style={styles.description}>{t('findFleets.completionDescription')}</span>
                    <span style={styles.activationTitle}>{t('findFleets.activatedFleets')}</span>
                    {fleetNames.map((fleetName, index) => (
                        <span key={`${fleetName}-${index}`} style={styles.fleetListItem}>
                            <span>{`${index + 1}. `}</span>
                            <span style={styles.fleetName}>{fleetName}</span>
                        </span>
                    ))}
                </Flex>
            </Flex>
        </Flex>
    );
};

export default CompletePage;
